export default {"src":"/_next/static/media/ethos-logo-forest.23ac5973.svg","height":56,"width":152,"blurWidth":0,"blurHeight":0};